<template>
  <div class="search-results">

      <div v-if="searchQuery">

        <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
            <div class="uk-light uk-container uk-container-small uk-text-center">
                <h1 class="uk-margin-top">Search Results for <em>{{searchQuery}}</em></h1>
                <p class="uk-text-lead" v-if="!!searchResults.length">{{searchResults.length}}{{ searchResults.length == 100 ? "+" : "" }} matches found</p>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-background-white">
            <div class="uk-container uk-container-small">
                <div class="uk-text-center" v-if="!!$apollo.loading">
                    <i class="uk-margin-small-right" uk-spinner></i> Waiting for Search Results...
                </div>
                <slot v-else>

                    <div v-for="item in searchResults" v-if="searchResults.length > 0">
        
                        <component :is="componentType(item)" :to="toCalc(item)" :href="hrefCalc(item)" :title="item.title" class="clean search-link" :target="targetCalc(item)" @click.native="closeSearch()">
                        <!-- <router-link:to="item.Link" :target="item.Link.indexOf('//')!==-1 ? '_blank' : false"  class="clean search-link"> -->
                            <h4><b>{{item.title}}</b> <small>{{item.targetClass.replace(/([A-Z])/g, ' $1').trim()}}</small></h4>
                        <!-- </router-link> -->
                        </component>
                    </div>

                    <p class="uk-text-center" v-else>No results matching <em>{{state.api.search.query}}</em></p>
                </slot>

            </div>
        </div>

    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import gql from 'graphql-tag'

// GraphQL query
// const apolloSearchQuery = gql`
//     query($query: String!) {
//         readSearchableObjects(
//             filter: { text: { contains: $query }}
//         ) {
//             nodes {
//                 title
//                 targetClass
//                 targetID
//                 link
//                 text
//             }
//         }
//     }
// `

const apolloSearchQuery = gql`
    query($query: String!) {
        search(
            query: $query
        ) {
            title
            targetClass
            targetID
            link
            text
        }
    }
`

export default {
    inject: ['state'],
    data() {
        return {
            searchQuery: '',
            loading: false,
            searchResults: []
        }
    },
    apollo: {
        searchResults: {
            query: apolloSearchQuery,
            // debounce: 100, 
            // throttle: 100,
            variables() {
                return {
                    query: this.searchQuery.toLowerCase()
                }
            },
            update(data) {

                // console.log('apollo data', data.readSearchableObjects.nodes)

                let weights = {
                    'Project': 1,
                    'Article': 2,
                    'Video': 3,
                    'CompetitionEntry': 4,
                    'Page': 5,
                    'Person': 6
                }

                return _(data.search).uniqBy((e) => {
                    return `${e.targetClass}_${e.targetID}`
                }).orderBy([ (e) => {
                    return weights[e.targetClass] || 99
                }, 'Title'], ['asc', 'asc']).value()
            },
            skip() {
                return !this.searchQuery
            }
        }
    },
    mounted() {
        this.checkSearch(this.$route)
    },
    watch: {
        'state.api.search.active': function(newActive, oldActive){
            if(!newActive) {
                this.$router.push({ query: {}})
            }
        },
        'state.api.search.query': _.debounce(function(newQuery, oldQuery) {
            this.state.api.search.queryCache = newQuery
            this.state.api.search.results = []
            this.searchQuery = newQuery
            if(newQuery=="") {
                // if(!this.api.search.active) {
                //
                // }
            }
            else {
                this.searchQuery = newQuery
                if(this.$route.query.search != newQuery) {
                    this.$router.push({ query: { search: newQuery }})
                }
            }
        }, 500),
        '$route' (to, from) {
            this.checkSearch(to)
        }
    },
    methods: {
        checkSearch(path) {
            if(path.query.search) {
                this.state.api.search.active = !!path.query.search
                this.state.api.search.query = path.query.search
            }
            else {
                this.state.api.search.active = false
            }
        },
        closeSearch() {
            // this.state.api.search.active = false;
            // this.state.api.search.query = '';
        },
        isExternal(item) {
            if(item.link) {
                return item.link.indexOf('http')!==-1
            }
        },
        targetCalc(item) {
            return this.isExternal(item) ? '_blank' : null
        },
        toCalc(item) {
            return !this.isExternal(item) ? item.link : null
        },
        hrefCalc(item) {
            return this.isExternal(item) ? item.link : null
        },
        componentType(item) {
            return this.isExternal(item) ? "a" : "router-link"
        }
    }
}

</script>
